"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkeletonLoader = exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _gutterBottom = _interopRequireDefault(require("../helpers/gutter-bottom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(_ref) {
  var palette = _ref.palette,
      mixins = _ref.mixins,
      constants = _ref.constants;
  return {
    root: _objectSpread({}, mixins.flex('center', 'flex-start'), {
      backgroundColor: palette.grey[300],
      width: '100%',
      height: 16
    }),
    fullWidth: {
      width: '100%'
    },
    rounded: {
      borderRadius: 8
    },
    centerContent: _objectSpread({}, mixins.flex('center', 'flex-start'), {
      justifyContent: 'space-around'
    }),
    blinkContent: {
      animationName: '$blink',
      animation: 'blink 1.25s linear infinite',
      animationFillMode: 'forwards',
      background: constants.loaderBackground,
      backgroundSize: '2000px 300px',
      position: 'relative',
      willChange: 'background'
    },
    '@keyframes blink': {
      from: {
        backgroundPosition: '-1000px 0'
      },
      to: {
        backgroundPosition: '1000px 0'
      }
    }
  };
};

exports.styles = styles;
var GUTTER_BOTTOM = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}; // eslint-disable-next-line prefer-arrow-callback

var SkeletonLoader = _react.default.forwardRef(function SkeletonLoader(props, ref) {
  var _classNames;

  var size = props.size,
      style = props.style,
      width = props.width,
      height = props.height,
      classes = props.classes,
      blink = props.blink,
      children = props.children,
      className = props.className,
      rounded = props.rounded,
      centered = props.centered,
      gutterBottom = props.gutterBottom,
      Component = props.component;
  var rootClass = (0, _classnames.default)(className, classes.root, (_classNames = {}, _defineProperty(_classNames, classes.fullWidth, !size && !width), _defineProperty(_classNames, classes.centerContent, centered), _defineProperty(_classNames, classes.blinkContent, blink), _defineProperty(_classNames, classes.rounded, rounded), _classNames));

  var loaderStyle = _objectSpread({
    height: height || size,
    width: width || size
  }, style);

  return _react.default.createElement(_gutterBottom.default, {
    gutterBottom: gutterBottom
  }, _react.default.createElement(Component, {
    className: rootClass,
    style: loaderStyle,
    ref: ref
  }, children));
});

exports.SkeletonLoader = SkeletonLoader;
process.env.NODE_ENV !== "production" ? SkeletonLoader.propTypes = {
  classes: _propTypes.default.object.isRequired,
  blink: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  component: _propTypes.default.elementType,
  gutterBottom: _propTypes.default.oneOf([GUTTER_BOTTOM.SMALL, GUTTER_BOTTOM.MEDIUM, GUTTER_BOTTOM.LARGE]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  rounded: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  style: _propTypes.default.object,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
} : void 0;
SkeletonLoader.defaultProps = {
  blink: true,
  centered: false,
  component: 'div',
  size: null,
  style: null,
  height: null,
  width: null,
  className: '',
  rounded: false,
  children: null,
  gutterBottom: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'SkeletonLoader'
})(SkeletonLoader);

exports.default = _default;